// NOTE: all types here are set to any to accomodate reusability

export const combineReducers = (reducers: any) => [
    (state: any, action: any) =>
        Object.entries(reducers).reduce(
            (acc: any, [key, [reducer, _]]: any) => {
                acc[key] = reducer(state[key], action)
                return acc
            },
            {}
        ),
    Object.entries(reducers).reduce(
        (acc: any, [key, [_, reducerState]]: any) => {
            acc[key] = reducerState
            return acc
        },
        {}
    ),
]
